var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-results"},[_c('div',{staticClass:"loading-results-inner"},[_c('div',{staticClass:"loading-results-logo"}),_c('p',[_vm._v(_vm._s(_vm.t('Creating your personalized nutrition plan...')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }